import React from 'react';

import '../style.css';
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import Ecoambit from "./menudesign/Ecoambit";
import Ingredients from "./menudesign/Ingredients";
import {AuthProvider} from "../config/AuthContext";
import Login from "./root/Login";
import Home from "./root/Home";
import Usuaris from "./root/Usuaris";
import Multilleure from "./multilleure/Multilleure";
import Algoritmix from "./multilleure/algoritmix/Algoritmix";
import Rebuts from "./multilleure/administracio/Rebuts";
import Remeses from "./multilleure/administracio/Remeses";
import Contactes from "./multilleure/gestioinscripcions/Contactes";
import FacturacioHolded from "./root/FacturacioHolded";
import Propostes from "./menudesign/comandes/Propostes";
import Comandes from "./menudesign/comandes/Comandes";
import GestorComandes from "./menudesign/comandes/GestorComandes";
import Stocks from "./menudesign/Stock/GestioStocks";
import ControlHoraris from "./root/ControlHoraris";
import AlgoritmixRebuts from "./multilleure/algoritmix/AlgoritmixRebuts";
import EstadistiquesHoraries from "./root/EstadistiquesHoraries";
import InscripcioGestio from "./inscripcions/InscripcioGestio";
import LoginInscripcions from "./inscripcions/LoginInscripcions";
import InscripcioGestioId from "./inscripcions/InscripcioGestioId";
import ConfiguracioCasals from "./multilleure/casals/ConfiguracioCasals";
import Activitats from "./multilleure/Activitats";
import Inscripcions from "./multilleure/casals/Inscripcions";
import Escoles from "./root/Escoles";
import AlumneCasal from "./multilleure/casals/AlumneCasal";
import PassarLlista from "./multilleure/casals/PassarLlista";
import EmailsCasals from "./multilleure/casals/EmailsCasals";
import Configuracions from "./root/Configuracions";
import Pantalles from "./root/Pantalles";
import Bundles from "./root/Bundles";
import Alergens from "./root/Alergens";
import Plats from "./menudesign/Plats";
import Menus from "./menudesign/Menus";
import Variants from "./menudesign/Variants";
import Proveidors from "./menudesign/Proveidors";
import Classes from "./menudesign/Classes";
import Participants from "./menudesign/Participants";
import Jobs from "./automatitzar/Jobs";
import Perfil from "./root/Perfil";
import Profile from "./root/Profile";
import Pagament from "./root/Pagament";
import Admin from './admin/Admin';
import Beques from './multilleure/extraescolars/Beques';
import Emails from './multilleure/extraescolars/Emails';
import ConfiguracioExtraescolars from './multilleure/extraescolars/ConfiguracioExtraescolars';
import GestioUsuarisAdmin from './admin/GestioUsuarisAdmin';
import ControlHorariAdmin from './admin/ControlHorariAdmin';
import InscripcionsE from "./multilleure/extraescolars/Inscripcions";
import GenerarPdf from "./multilleure/administracio/GenerarPdf";

const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/multilleure/algoritmix" element={<Algoritmix/>}/>
                <Route path="/multilleure/rebuts" element={<Rebuts/>}/>
                <Route path="/multilleure/remeses" element={<Remeses/>}/>
                <Route path="/multilleure/contactes" element={<Contactes/>}/>
                <Route path="/multilleure/algoritmixrebuts" element={<AlgoritmixRebuts/>}/>
                <Route path="/multilleure/configuraciocasals" element={<ConfiguracioCasals/>}/>
                <Route path="/multilleure/activitats" element={<Activitats/>}/>
                <Route path="/multilleure/inscripcions" element={<Inscripcions/>}/>
                <Route path="/multilleure/inscripcions/:id_contacte/activitat/:id_activitat" element={<Inscripcions/>}/>
                <Route path="/multilleure/alumnecasal" element={<AlumneCasal/>}/>
                <Route path="/multilleure/passarllista" element={<PassarLlista/>}/>
                <Route path="/multilleure/emailscasals" element={<EmailsCasals/>}/>
                <Route path="/multilleure/emails" element={<Emails/>}/>
                <Route path="/multilleure/inscripcionsextraescolars" element={<InscripcionsE/>}/>
                <Route path="/multilleure/configuracioextraescolars" element={<ConfiguracioExtraescolars/>}/>
                <Route path="/multilleure/generarpdf" element={<GenerarPdf/>}/>

                <Route path="/artsiesports/algoritmix" element={<Algoritmix/>}/>
                <Route path="/artsiesports/rebuts" element={<Rebuts/>}/>
                <Route path="/artsiesports/rebuts/:dni" element={<Rebuts/>}/>
                <Route path="/artsiesports/remeses" element={<Remeses/>}/>
                <Route path="/artsiesports/contactes" element={<Contactes/>}/>
                <Route path="/artsiesports/algoritmixrebuts" element={<AlgoritmixRebuts/>}/>
                <Route path="/artsiesports/configuraciocasals" element={<ConfiguracioCasals/>}/>
                <Route path="/artsiesports/activitats" element={<Activitats/>}/>
                <Route path="/artsiesports/inscripcions" element={<Inscripcions/>}/>
                <Route path="/artsiesports/inscripcions/:id_contacte/activitat/:id_activitat"
                       element={<Inscripcions/>}/>
                <Route path="/artsiesports/alumnecasal" element={<AlumneCasal/>}/>
                <Route path="/artsiesports/passarllista" element={<PassarLlista/>}/>
                <Route path="/artsiesports/emailscasals" element={<EmailsCasals/>}/>
                <Route path="/artsiesports/beques" element={<Beques/>}/>
                <Route path="/artsiesports/emails" element={<Emails/>}/>
                <Route path="/artsiesports/inscripcionsextraescolars" element={<InscripcionsE/>}/>
                <Route path="/artsiesports/generarpdf" element={<GenerarPdf/>}/>


                <Route path="/ecoambit/ingredients" element={<Ingredients/>}/>
                <Route path="/ecoambit/plats" element={<Plats/>}/>
                <Route path="/ecoambit/menus" element={<Menus/>}/>
                <Route path="/ecoambit/alergies" element={<Variants/>}/>
                <Route path="/ecoambit/proveidors" element={<Proveidors/>}/>
                <Route path="/ecoambit/clases" element={<Classes/>}/>
                <Route path="/ecoambit/participants" element={<Participants/>}/>
                <Route path="/ecoambit/propostes" element={<Propostes/>}/>
                <Route path="/ecoambit/comandes" element={<Propostes/>}/>
                <Route path="/ecoambit/propostes/:id" element={<Comandes/>}/>
                <Route path="/ecoambit/gestorcomandes" element={<GestorComandes/>}/>
                <Route path="/ecoambit/stock" element={<Stocks/>}/>

                <Route path="/menudesign/ingredients" element={<Ingredients/>}/>
                <Route path="/menudesign/plats" element={<Plats/>}/>
                <Route path="/menudesign/menus" element={<Menus/>}/>
                <Route path="/menudesign/alergies" element={<Variants/>}/>
                <Route path="/menudesign/proveidors" element={<Proveidors/>}/>
                <Route path="/menudesign/clases" element={<Classes/>}/>
                <Route path="/menudesign/participants" element={<Participants/>}/>
                <Route path="/menudesign/propostes" element={<Propostes/>}/>
                <Route path="/menudesign/comandes" element={<Propostes/>}/>
                <Route path="/menudesign/propostes/:id" element={<Comandes/>}/>
                <Route path="/menudesign/gestorcomandes" element={<GestorComandes/>}/>
                <Route path="/menudesign/stock" element={<Stocks/>}/>


                <Route path="/controlhorari" element={<ControlHoraris/>}/>
                <Route path="/treballadors" element={<Perfil/>}/>
                <Route path="/configuracions" element={<Configuracions/>}/>
                <Route path="/pantalles" element={<Pantalles/>}/>
                <Route path="/bundles" element={<Bundles/>}/>
                <Route path="/alergens" element={<Alergens/>}/>
                <Route path="/profile" element={<Perfil/>}/>
                <Route path="/profile/:id_usuari/:empresa" element={<Profile/>}/>
                <Route path="/profile/:id_usuari" element={<Profile/>}/>
                <Route path="/controlhorari/:id_usuari/:empresa" element={<EstadistiquesHoraries/>}/>
                <Route path="/controlhorari/:id_usuari" element={<EstadistiquesHoraries/>}/>
                <Route path="/pagament" element={<Pagament/>}/>


                <Route path="/inscripcions/gestio" element={<InscripcioGestio/>}/>
                <Route path="/inscripcions/gestio/:id_inscripcio" element={<InscripcioGestioId/>}/>
                <Route path="/inscripcions/gestio/:id_inscripcio/documentacio" element={<InscripcioGestioId/>}/>


                <Route path="/automatitzar" element={<Jobs/>}/>
                <Route path="/facturacioholded" element={<FacturacioHolded/>}/>

                <Route path='/admin/configuraciousuaris' element={<GestioUsuarisAdmin/>}/>
                <Route path='/admin/controlhorari' element={<ControlHorariAdmin/>}/>

                <Route path="/admin" element={<Admin/>}/>
                <Route path="/ecoambit" element={<Ecoambit/>}/>
                <Route path="/inscripcions" element={<LoginInscripcions/>}/>
                <Route path="/multilleure" element={<Multilleure/>}/>
                <Route path="/home" element={<Home/>}/>
                <Route path="/configuraciousuaris" element={<Usuaris/>}/>
                <Route path="/escoles" element={<Escoles/>}/>
                <Route path="/" element={<Login/>}/>
            </Routes>
        </Router>
    );
}

function Root() {
    return (
        <AuthProvider>
            <App/>
        </AuthProvider>
    );
}

export default Root;
